module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "password-reset-component"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.passwordResetSucceeded) ? _c('el-alert', {
    attrs: {
      "title": "Success",
      "type": "success",
      "description": "Your password has been reset successfully!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordResetFailed) ? _c('el-alert', {
    attrs: {
      "title": "Password Reset Failed",
      "type": "error",
      "description": "We couldn't reset your password. Please contact COLONY LIVE support for further assistance."
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.passwordResetSucceeded) ? _c('div', [_c('PasswordOnlyResetForm')], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [(!_vm.passwordResetSucceeded) ? _c('div', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Already have an account?")])], 1) : _c('div', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-purple"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logos/logo-white-live.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-icon",
    attrs: {
      "src": "static/assets/icons/auth/lock.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey text-white text-center welcome-message"
  }, [_c('h4', [_vm._v("Password Recovery")]), _vm._v(" "), _c('p', [_vm._v("\n        Sorry to hear you forgot your password. "), _c('br'), _vm._v("Please provide the email address for the account you wish to reset.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5475bc7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/auth/PasswordRestWithTokenForm.vue
// module id = 3285
// module chunks = 3